export interface DebeMostrarBloqueSeoParams {
  esHome: boolean;
  pais: string;
  origen: string | undefined;
}

export const debeMostrarBloqueSeo = ({
  esHome,
  pais,
  origen,
}: DebeMostrarBloqueSeoParams): boolean => {
  return esHome === true && pais === "AR" && origen === "SEGURARSE";
};
